export const TIME_SLOT_KEYS = ['morning', 'afternoon', 'evening', 'allDay'];

export const TIME_SLOT_LABELS = {
  morning: 'Morning',
  afternoon: 'Afternoon',
  evening: 'Evening',
  allDay: 'All Day',
};

function isWeekendDate(d) {
  const dow = d.day();
  return dow === 0 || dow === 6;
}

function isProviderHoliday(serviceProvider, dateStr) {
  const list = serviceProvider?.workSchedule?.holidays;
  if (!Array.isArray(list)) return false;
  return list.some(h => h?.holidayDate === dateStr);
}

function scheduleForDate(serviceProvider, date) {
  const dateStr = date.format('YYYY-MM-DD');
  if (isProviderHoliday(serviceProvider, dateStr)) {
    return null;
  }
  const ws = serviceProvider?.workSchedule;
  if (!ws) return null;
  return isWeekendDate(date) ? ws.weekends : ws.weekdays;
}

/** When `availableDates` is set (non-null array), the date must be listed. */
function isDateOnProviderAvailableDates(serviceProvider, dateStr) {
  const ad = serviceProvider?.availableDates;
  if (ad == null) return true;
  if (!Array.isArray(ad)) return true;
  if (ad.length === 0) return false;
  return ad.includes(dateStr);
}

function scheduleHasAnySlotEnabled(schedule) {
  if (!schedule) return false;
  return Boolean(
    schedule.morning ||
    schedule.afternoon ||
    schedule.evening ||
    schedule.allDay,
  );
}

export function isProviderAvailableInSlot(serviceProvider, date, slotKey) {
  const dateStr = date.format('YYYY-MM-DD');
  if (!isDateOnProviderAvailableDates(serviceProvider, dateStr)) {
    return false;
  }
  const schedule = scheduleForDate(serviceProvider, date);
  if (!scheduleHasAnySlotEnabled(schedule)) {
    return false;
  }
  if (slotKey === 'allDay') {
    return Boolean(schedule.allDay);
  }
  if (schedule.allDay) {
    return true;
  }
  return Boolean(schedule[slotKey]);
}

export function getProvidersForSlot(serviceProviders, date, slotKey) {
  if (!Array.isArray(serviceProviders)) return [];
  const candidates = serviceProviders.filter(sp =>
    isProviderAvailableInSlot(sp, date, slotKey),
  );
  if (candidates.length === 0) return [];
  candidates.sort((a, b) => String(a.id).localeCompare(String(b.id)));
  return [candidates[0]];
}

export function dayHasAnySlot(serviceProviders, date) {
  return TIME_SLOT_KEYS.some(
    slot => getProvidersForSlot(serviceProviders, date, slot).length > 0,
  );
}

/** Morning, afternoon, or evening; all-day providers count toward each segment. */
export function dayHasProvidersInSegment(serviceProviders, date, segmentKey) {
  const direct = getProvidersForSlot(serviceProviders, date, segmentKey).length;
  const allDay = getProvidersForSlot(serviceProviders, date, 'allDay').length;
  return direct + allDay > 0;
}

export function listDatesInRange(start, end) {
  const out = [];
  let cursor = start.startOf('day');
  const last = end.startOf('day');
  while (!cursor.isAfter(last, 'day')) {
    out.push(cursor);
    cursor = cursor.add(1, 'day');
  }
  return out;
}

export function getHorizonEnd(today, maxDays) {
  return today.add(maxDays - 1, 'day');
}
